// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line-item-customizations .line-item-customizations__option-link[data-v-c473ae92]{color:#f37053}.line-item-customizations .line-item-customizations__option-link[data-v-c473ae92]:hover{text-decoration:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
